<!-- 计费方案列表 -->
<template>
    <div class="container containerBox scheme-box">
        <el-card class="box-card" style="border:0;" shadow="never">
            <div slot="header" class="clearfix">
                <span>计费方案列表</span>
                <div class="fr">
                    
                </div>
            </div>
            <div>
                <el-button plain class="addScheme" @click="handleAddScheme" icon="el-icon-plus">添加方案</el-button>
                <el-table
                    :data="tableData"
                    stripe
                    @row-click="handleRowClick"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="RuleName"
                        label="方案名称">
                    </el-table-column>
                    <el-table-column
                        prop="Description"
                        label="备注信息">
                    </el-table-column>
                    <el-table-column
                        prop="UsableType"
                        label="是否可用">
                        <template slot-scope="scope">
                            <el-tag
                            :type="scope.row.UsableType === 1 ? 'success' : 'info'"
                            size="small"
                            disable-transitions>{{fmtUsableType(scope.row)}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                            <el-button type="primary" @click.stop="handleSetting(scope.row)" size="small">设置</el-button>
                            <el-button @click.stop="handleEdit(scope.row)" size="small">编辑</el-button>
                            <el-button @click.stop="handleDetele(scope.row)" type="danger" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <!-- 方案详情弹框 -->
        <div>
            <cmp-scheme-detail :show.sync="show" :modelData="schemeDetail" ></cmp-scheme-detail>
        </div>

        <!-- 添加方案弹框 -->
        <el-dialog title="添加方案" :visible.sync="dialogFormVisible">
            <el-form :model="addForm" ref="addForm" label-width="120px">
                <el-form-item 
                    label="方案名称"
                    prop="rulename"
                    :rules="[
                        { required: true, message: '请输入方案名称', trigger: 'blur' },
                    ]"
                >
                    <el-input v-model="addForm.rulename"></el-input>
                </el-form-item>
                <el-form-item label="方案备注">
                    <el-input v-model="addForm.description"></el-input>
                </el-form-item>
                <el-form-item label="是否可用">
                    <el-radio-group v-model="addForm.usabletype">
                        <el-radio :label="1">可用</el-radio>
                        <el-radio :label="2">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CmpSchemeDetail from './CmpSchemeDetail'
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
export default {
    name: "chargeschemelist",
    inject: ["reload"],
    data () {
        return {
            // 详情props
            show: false,
            schemeDetail: '',
            // 方案列表
            tableData: [],

            // 添加方案
            dialogFormVisible: false,
            addForm: {
                usabletype:1,   // 默认可见
            },
        };
    },
    components: {
        CmpSchemeDetail
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取计费方案列表
        async getList() {
            let data = await Service.getChargeSchemeList({});
            if(data) {
                data = data == 'success'? [] : data;
                this.tableData = data;
            }
        },
        // 是否可用
        fmtUsableType(row){
            switch (row.UsableType) {
                case 1:
                    return '可用'
                case 2:
                    return '禁用'
                default:
                    break;
            }
        },
        // 添加方案弹框
        handleAddScheme() {
            this.addForm = {
                usabletype:1,
            }
            this.dialogFormVisible = true;
        },
        // 添加方案
        handleSave() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let data
                    if(this.addForm.OID){
                        // 编辑
                        data = await Service.editChargeScheme(this.addForm);
                    }else{
                        // 添加
                        data = await Service.addChargeScheme(this.addForm);
                    }
                    if(data){
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                        this.reload();
                    }
                } else {
                    return false;
                }
            })
        },
        // 编辑方案
        handleEdit(row) {
            this.addForm = {
                OID: row.OID,
                rulename: row.RuleName,
                description: row.Description,
                usabletype:row.UsableType,
            }
            this.dialogFormVisible = true;
        },
        // 设置方案
        handleSetting(row) {
            this.$router.push("/chargeschemelist/addchargescheme/"+row.OID)
        },
        // 删除方案
        handleDetele(row) {
            $Alert(`是否确认删除 ${row.RuleName} `).then( async (bool)=>{
                if(bool){
                    let data = await Service.deteleChargeScheme({ OID: row.OID });
                    if(data) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                        });
                        // 刷新列表数据
                        this.reload();
                    }
                }
            });
        },
        // 查看方案详情
        handleRowClick(row) {
            // 判断方案是否填写完善
            
            this.show = true;
            this.schemeDetail = row;
        }
    }
}

</script>
<style lang='less' scoped>
.addScheme{
    color: rgba(0,0,0,.65);
    background-color: #fff;
    border-color: #d9d9d9;
    border-style: dashed;
    width: 100%;
    margin: 10px 0 30px;
}
</style>